<template>
  <v-dialog v-bind:value="value" v-on:input="close" width="400" v-bind:persistent="importing">
    <v-card>
      <v-card-title>Importazione clienti</v-card-title>

      <v-card-text>
        <v-carousel
          v-bind:show-arrows="false"
          v-model="step"
          height="200"
          hide-delimiters
          hide-delimiter-background
          light
        >
          <v-carousel-item>
            <v-sheet height="100%">
              Seleziona il file con estensione <strong>xls</strong> o <strong>csv</strong> contenente i dati dei clienti.
              <v-file-input
                ref="importFile"
                v-model="file"
                v-bind:error-messages="errorMessage"
                label="File da importare"
                accept=".xls,.xlsx,.csv"
                show-size
              />
            </v-sheet>
          </v-carousel-item>

          <v-carousel-item>
            <v-sheet height="100%">
              Vuoi disabilitare i clienti che non sono presenti nel file da importare ?
              (Non verranno comunque eliminati, ma non potranno essere utilizzati per creare nuove notifiche)
              <v-checkbox
                v-model="replace"
                label="Disabilita i clienti non presenti nel file"
              />
            </v-sheet>
          </v-carousel-item>

          <v-carousel-item>
            <v-sheet height="100%">
              Procedi con l'importazione dei dati da file, potrebbero volerci alcuni minuti al completamento dell'operazione.
            </v-sheet>
          </v-carousel-item>
          <v-carousel-item>
            <v-sheet height="100%" v-if="importing">
              <v-sheet>Importazione in corso...</v-sheet>
              <v-sheet class="d-flex" height="100%">
                <v-progress-circular
                  class="ma-auto"
                  color="primary"
                  v-bind:size="80"
                  v-bind:width="7"
                  indeterminate
                />
              </v-sheet>
            </v-sheet>

            <v-sheet height="100%" v-if="statistics">
              Risultato dell'importazione:
              <ul>
                <li>Totale clienti importati: <strong>{{ statistics.total }}</strong></li>
                <li>Clienti disattivati: <strong>{{ statistics.deactivated }}</strong></li>
                <li>Clienti nuovi: <strong>{{ statistics.inserted }}</strong></li>
                <li>Clienti aggiornati: <strong>{{ statistics.updated }}</strong></li>
              </ul>
            </v-sheet>
          </v-carousel-item>
        </v-carousel>
      </v-card-text>

      <v-card-actions>
        <v-btn
          v-on:click="prevStep"
          v-show="step"
          v-bind:disabled="importing"
          icon
          large
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-spacer />
        <v-btn
          v-on:click="nextStep"
          v-show="!lastStep"
          icon
          large
        >
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
        <v-btn class="primary" v-show="lastStep && !importing" v-on:click="close">Chiudi</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import server from '../mixins/server'
import utils from '../mixins/utils'

export default {
  name: 'ImportCustomers',

  mixins: [ server, utils ],

  props: {
    value: {
      type: Boolean,
      default: false,
    }
  },

  data: () => ({
    replace: false,
    file: null,
    statistics: null,
    step: 0,
    importing: false,
    showError: false,
  }),

  computed: {
    lastStep: function() { return this.step === 3; },
    errorMessage: function() { return (this.showError && !this.file) ? 'Valore richiesto.' : ''; },
  },

  methods: {
    prevStep: function() {
      // Reset statistics after importing
      this.lastStep && (this.statistics = null);
      this.step--;
    },

    nextStep: function() {
      if (!this.file) {
        this.showError = true;
      } else if (!this.lastStep) {
        this.step++;

        // Import data
        if (this.lastStep) {
          this.importing = true;
          this.server_upload({
            url: 'Customer/import',
            parameters: (this.replace) ? { replace: true } : {},
            data: { userfile: this.file },
            onError: () => { this.importing = false; },
            onSuccess: (data) => {
              this.importing = false;
              this.statistics = data;
            }
          });
        }
      }
    },

    close: function() {
      this.$emit('input', false);
      this.statistics = null;
      this.file = null;
      this.replace = false;
      this.step = 0;
      this.showError = false;
    },
  }
}
</script>
